import { Dialog, DialogContent, DialogTitle, DialogActions, Stack, Button } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/form-provider';
import LoadingButton from '@mui/lab/LoadingButton';
import useRefuseDialog from './refuse-dialog.hook';

type Props = {
  hook: any;
};

export default function RefuseDialog({ hook }: Props) {
    const {methods, onSubmit} = useRefuseDialog()
  return (
    <Dialog maxWidth="sm" fullWidth open={hook.openRefuse} onClose={hook.onCloseRefuse}>
      <DialogTitle>Recusar Cupom</DialogTitle>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <RHFTextField
              name="declineComment"
              label="Motivo da recusa"
              placeholder="Digite o motivo da recusa do cupom..."
              multiline
              rows={4}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={hook.onCloseRefuse} color="inherit">
            Cancelar
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
          >
            Recusar Cupom
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
